
function readCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export default function () {
  if (readCookie('_cioid')) {
    analytics.identify(readCookie('_cioid'));
  }

  if (readCookie('ajs_user_id')) {
    try {
      var userId = JSON.parse(decodeURIComponent(readCookie('ajs_user_id')));
      if (userId !== null) {
        analytics.identify(userId);
      }
    } catch (e) {}
  }

  analytics.track('Page Viewed');

  analytics.ready(function () {
    ga('require', 'linker');
    ga('linker:autoLink', ['watsi.org', 'blog.watsi.org']);
  });
}
